<div class="badge-name">{{ badge.name }}</div>
<div class="circle-small" style="position: relative">
  <div class="progress-icon" *ngIf="progress == 100">
    <i style="font-size: 8px" class="fa fa-check"></i>
  </div>

  <div class="circle-wrap" [style]="'transform: rotate(' + rotate + 'deg)'">
    <div class="circle">
      <div class="mask full" [style]="'transform: rotate(' + degrees + 'deg)'">
        <div class="fill" [style]="'transform: rotate(' + degrees + 'deg)'"></div>
      </div>
      <div class="mask half">
        <div class="fill" [style]="'transform: rotate(' + degrees + 'deg)'"></div>
      </div>
      <div class="inside-circle"></div>
    </div>
  </div>
  <img
    [src]="'/assets/images/gamification/badge-' + badge.name.toLowerCase() + '.svg'"
    [alt]="badge.name"
    style="vertical-align: middle; top: 0px; left: 3px; position: absolute"
    class="badge-image"
  />
</div>

<div class="badge-earnings">
  {{ (badge.reward | currency : 'GBP' : 'symbol' : '1.2-2') || 'TBC' }}
</div>
<div class="earn-label">{{ badge.earnValue }} Jobs</div>
